import { render, staticRenderFns } from "./rejected-loan.vue?vue&type=template&id=0830799e&scoped=true&"
import script from "./rejected-loan.vue?vue&type=script&lang=js&"
export * from "./rejected-loan.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0830799e",
  null
  
)

export default component.exports